import { render, staticRenderFns } from "./ApplyClientsDialog.vue?vue&type=template&id=2ef5ef66&scoped=true&"
import script from "./ApplyClientsDialog.vue?vue&type=script&lang=ts&"
export * from "./ApplyClientsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyClientsDialog.vue?vue&type=style&index=0&id=2ef5ef66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5ef66",
  null
  
)

export default component.exports